import { Form, Input } from 'antd';
import React from 'react';

import { IFieldBase } from '../../interfaces';
import { ItemTaskType } from '../../types';

const FieldWoSi: React.FC<IFieldBase> = ({ disabled }) => {
    return (
        <Form.Item<ItemTaskType> label="WO / SI #" name="wo_si">
            <Input disabled={disabled} />
        </Form.Item>
    );
};

export default React.memo(FieldWoSi);
